import React, { FC } from 'react';
import { Tooltip } from '@clearcover/atlas';

import styles from './styles.module.css';

type PolicyProductSegmentIndicatorProps = {
  productSegment: string;
};

const SEGMENT_MAP: Record<string, string> = {
  standardAuto: 'SA',
  nonStandardAuto: 'NSA',
};

export const PolicyProductSegmentIndicator: FC<
  PolicyProductSegmentIndicatorProps
> = ({ productSegment }) => {
  const segment = SEGMENT_MAP[productSegment];

  return (
    <Tooltip
      position="top"
      tooltip={`The product segment for this policy is ${segment}`}
    >
      <span className={styles.indicator}>{segment}</span>
    </Tooltip>
  );
};

PolicyProductSegmentIndicator.displayName = 'PolicyProductSegmentIndicator';
